import { render, staticRenderFns } from "./editWorkPoints.vue?vue&type=template&id=661dbd97&scoped=true&lang=html&"
import script from "./editWorkPoints.vue?vue&type=script&lang=js&"
export * from "./editWorkPoints.vue?vue&type=script&lang=js&"
import style0 from "./editWorkPoints.vue?vue&type=style&index=0&id=661dbd97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661dbd97",
  null
  
)

export default component.exports